import { createSlice } from "@reduxjs/toolkit";

const initialPasoDos = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    pasoDosAlUnoInformacion: undefined,
    establecimientos: [],
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const pasoDosSlice = createSlice({
    name: "pasoDos",
    initialState: initialPasoDos,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        starCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        pasoDosAlUnoFetched: (state, action) => {
            state.actionsLoading = false;
            state.pasoDosAlUnoInformacion = action.payload.pasoDosAlUnoInformacion;
            state.error = null;
        },
        pasoDosAlTresFetched: (state, action) => {
            state.actionsLoading = false;
            state.establecimientos = action.payload.establecimientos;
            state.error = null;
        },
        stateLimpiar: (state, action) => {
            state.actionsLoading = false;
            state.establecimientos = [];
            state.entities = null;
            state.pasoDosAlUnoInformacion = undefined;
            state.error = null;
        },
    }
}); 